import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { connect } from 'react-redux';
import { goBack } from 'connected-react-router';

const Breadcrumbs = ({ steps, currentStep, formTitle, onBackHandler, barClass = 'breadcrumbsBar' }) => {
    const lastStep = steps === undefined ? 0 : steps.length;
    return (
        <div className={barClass}>
            <span className='breadcrumbsBackButton circle-button button-next small hide'>
                <span onClick={onBackHandler}>{'<'}</span>
            </span>
            {steps === undefined || (steps.length === 0 && <div />)}
            {steps !== undefined && steps.length > 0 && (
                <span>
                    {steps.map((step, index) => {
                        let elementClass = classnames({
                            breadcrumbsStepLabel: true,
                            currentStep: step.stepNumber === currentStep
                        });
                        return (
                            <span className={elementClass} key={index}>
                                {step.stepNumber}. {step.stepTitle}
                                {step.stepNumber !== lastStep && <span className='breadcrumbsStepSeparator'>{'->'}</span>}
                            </span>
                        );
                    })}
                </span>
            )}
        </div>
    );
};

Breadcrumbs.propTypes = {};

const mapDispatchToProps = (dispatch, props) => ({
    onBackHandler: () => dispatch(goBack())
});

export default connect(
    null,
    mapDispatchToProps
)(Breadcrumbs);
